import { type Locale } from 'date-fns'
import { enUS, es, frCA } from 'date-fns/locale'
import { formatInTimeZone } from 'date-fns-tz'

const LANGUAGE_TO_LOCALE: Record<string, Locale> = {
  en_US: enUS,
  es_MX: es,
  fr_CA: frCA,
}

export const getDateFnsLocale = (language?: string): Locale => {
  if (!language) return enUS
  return LANGUAGE_TO_LOCALE[language] ?? enUS
}

export const toLocaleDateString = (date: Date): string => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return formatInTimeZone(date, timezone, 'EEE, d LLL yyyy p zzz')
}

export const toLocaleDateStringCustomFormat = (
  date: Date,
  customFormat: string
): string => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return formatInTimeZone(date, timezone, customFormat)
}

export const formatLocalTime = (date: Date): string => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return formatInTimeZone(date, timezone, 'h:mm a zzz')
}
